import { render } from "./SortControl.vue?vue&type=template&id=0f96845f&scoped=true"
import script from "./SortControl.vue?vue&type=script&lang=js"
export * from "./SortControl.vue?vue&type=script&lang=js"

import "./SortControl.vue?vue&type=style&index=0&id=0f96845f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f96845f"]])

export default __exports__